import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNPatient } from 'src/app/models/cnpatient';
import { CNProtocol } from 'src/app/models/cnprotocol';
import { ProtocolService, ProtocolServiceFilter, ProtocolServiceSubject } from 'src/app/services/protocol.service';

@ManageType('ProtocolTableComponent')
@Component({
  selector: 'app-protocol-table',
  templateUrl: './protocol-table.component.html',
  styleUrls: ['./protocol-table.component.scss']
})
export class ProtocolTableComponent implements OnInit {

  displayedColumns: string[] = ['protocol'];
  public protocols = new MatTableDataSource<CNProtocol>();
  public subject: ProtocolServiceSubject;
  private myLocation = 'default';
  private myPatient: CNPatient;
  private myShowPaginator = true;
  private myFilter = ProtocolServiceFilter.all;

  @ViewChild('paginator', { static: true }) thePaginator;
  @Input() pageSize = 5;

  constructor(public protocolservice: ProtocolService) { }

  ngOnInit(): void {
    this.protocolservice.clear.subscribe(flag => {
      console.log('protocols cleared');
      if (this.myShowPaginator) {
        this.thePaginator.pageIndex = 0;
      }
    });
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.protocolservice.getSubject(this.myLocation, this.myFilter, this.pageSize);
    this.subject.protocols.subscribe(data => {
      this.protocols.data = data;
    });
    if (this.myPatient) {
      this.subject.patient = this.myPatient;
    }
  }

  @Input() set paginator(flag: boolean) {
    this.myShowPaginator = flag;
  }

  get paginator(): boolean {
    return this.myShowPaginator;
  }

  @Input() set patient(thePatient: CNPatient) {
    this.myPatient = thePatient;
    if (this.subject) {
      // subject already set, just set patient
      this.subject.clear();
      this.subject.patient = this.myPatient;
    }
  }

  changePage(event: PageEvent): void {
    if (!this.subject) {
      return;
    }
    if (this.subject.limit !== event.pageSize) {
      this.subject.limit = event.pageSize;
    }
    const newStart = event.pageIndex * event.pageSize;
    if (newStart !== this.subject.start) {
      this.subject.start = newStart;
    }
  }

  updated(event: CNProtocol) {
    setTimeout(() => {
      this.subject.start = this.subject.start; // Force reload
    });
  }

}
